import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/components/Home.vue';
import Service from '@/components/Service.vue';
import Case from '@/components/Case.vue';
import Partner from '@/components/Partner.vue';
import Contact from '@/components/Contact.vue';
import CaseDetail from '@/components/CaseDetail.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/home',
        component: Home,
        meta: { keepAlive: true }
    },
    {
        path: '/service',
        component: Service,
        meta: { keepAlive: true }
    },
    {
        path: '/case',
        component: Case,
        meta: { keepAlive: true }
    },
    {
        path: '/case/:id',
        component: CaseDetail,
    },
    {
        path: '/partner',
        component: Partner,
        meta: { keepAlive: true }
    },
    {
        path: '/contact',
        component: Contact,
        meta: { keepAlive: true }
    },
    {
        path: '*',
        redirect: '/home'
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;  
    // 兼容IE
    window.scrollTo(0, 0);
    next();
})

export default router;
